import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAddress } from '../../models/address.model';
import { AppState } from '../app.state';
import { BaseFacade } from '../base.facade';
import { fromAddressActions } from './address.actions';
import { AddressSelector } from './address.selectors';

@Injectable()
export class AddressFacade extends BaseFacade {
	constructor(store: Store<AppState>, private addressSelector: AddressSelector) {
		super(store);
	}

	public isSuggesting$ = this.store.select(this.addressSelector.isSuggesting);
	public suggestedPayerList$ = this.store.select(this.addressSelector.suggestedPayerList);
	public suggestedPayerComplete$ = this.store.select(this.addressSelector.suggestedPayerComplete);
	public suggestedPayerIncomplete$ = this.store.select(this.addressSelector.suggestedPayerIncomplete);
	public suggestedReceiverList$ = this.store.select(this.addressSelector.suggestedReceiverList);
	public suggestedReceiverComplete$ = this.store.select(this.addressSelector.suggestedReceiverComplete);
	public suggestedReceiverIncomplete$ = this.store.select(this.addressSelector.suggestedReceiverIncomplete);

	public suggestPayer(address: IAddress): void {
		this.store.dispatch(fromAddressActions.suggestPayer({ address }));
	}

	public suggestReceiver(address: IAddress): void {
		this.store.dispatch(fromAddressActions.suggestReceiver({ address }));
	}
}
